// extracted by mini-css-extract-plugin
export default {"container":"mobile_summary_container_container__arOCd"};